import React, { ReactNode, useState } from "react"
import { FormattedMessage, } from "react-intl"
import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import Icon from "../../../common/icon/icon.component.jsx"
import PricingTableModal from "../pricingtablemodal.component.jsx"
import NumericLabel from "react-pretty-numbers"
import { StockDocumentTimelineProps } from "../../../common/types/timeline"

const StockDocumentSentComponent = (props: StockDocumentTimelineProps) => {
    const [modal, setModal] = useState<ReactNode>(null)

    const numberLabel = {
        justification: "L",
        locales: AppContext.getLocale().getLanguage(),
        currency: true,
        currencyIndicator: props.stockDocument.attributes.table.attributes.currency,
        percentage: false,
        precision: 0,
        commafy: false,
        shortFormat: true,
        title: true,
    }

    const showModal = () => {
        setModal(
            <PricingTableModal
                object={props.stockDocument.attributes.table}
                onClose={() => setModal(<></>)}
                persistState={true}
            />
        )
    }

    const totalAmount = props.stockDocument.attributes.table.attributes.totals[0].attributes.totalAmount

    return <div className={"row"}>
        {modal}
        <div className="col-12">
            <p className={"mb-1"}>
                <FormattedMessage
                    id="quote.events.stock_document_sent.text"
                    defaultMessage="{document} {identifier} has been sent for a total value of {totalValue}"
                    values={{
                        document: props.stockDocument.attributes.definition.attributes.name,
                        identifier: <strong>{props.stockDocument.attributes.identifier}</strong>,
                        totalValue: (
                            <strong>
                                <NumericLabel params={numberLabel}>
                                    {totalAmount}
                                </NumericLabel>
                            </strong>
                        ),
                    }}
                />
            </p>
        </div>
        <div className={"col-12 col-md-6 col-lg-4"}>
            <p className={"mb-2"}>
                <button className={"btn btn-sm btn-outline-primary"} onClick={showModal}>
                    <Icon value={"dollar-sign"} className={"mr-1"}/>
                    <FormattedMessage
                        id="quote.events.stock_document_sent.show_details"
                        defaultMessage="Show details"
                    />
                </button>
            </p>
        </div>
    </div>
}

export default StockDocumentSentComponent








// WEBPACK FOOTER //
// ./src/quote/analytics/events/stock-document-sent.component.tsx